import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ShipmentBoxModel } from '../../../../../modules/warehouse-management/features/shipment-boxes/models/shipment-box.model';
import { DimensionUnits, WeightUnits } from '../../../../enums/enum';
import { TransferDispatchBoxResponse } from '../../models/transfer-dispatchbox.model';

@Component({
  selector: 'app-box-suggestion',
  standalone: false,
  templateUrl: './box-suggestion.component.html',
  styleUrl: './box-suggestion.component.css',
})
export class BoxSuggestionComponent {
  @Input() allBox: ShipmentBoxModel[] = [];
  @Input() recomendedBox: ShipmentBoxModel[] = [];
  @Output() confirmBoxes = new EventEmitter<ShipmentBoxModel[]>();

  weightUnits = WeightUnits;
  dimensionUnits = DimensionUnits;
  selectedBox: ShipmentBoxModel[] = [];
  dispatchBoxes: TransferDispatchBoxResponse[] = [];
  quantity: number = 1;

  ngOnInit(): void {
    this.splitBoxes();
  }

  splitBoxes(): void {
    this.allBox = this.allBox.filter((box) => !this.recomendedBox.includes(box));
  }

  isSelected(box: ShipmentBoxModel): boolean {
    return this.selectedBox?.some((sb) => sb.id === box.id) ?? false;
  }

  toggleSelection(box: ShipmentBoxModel): void {
    const exists = this.selectedBox.some((sb) => sb.id === box.id);
    if (exists) {
      // remove ALL boxes with same id
      this.selectedBox = this.selectedBox.filter((sb) => sb.id !== box.id);
    } else {
      // add box
      this.selectedBox.push(box);
    }
  }

  increaseQuantity(box: ShipmentBoxModel): void {
    this.selectedBox.push(box);
  }

  decreaseQuantity(box: ShipmentBoxModel): void {
    const index = this.selectedBox.findIndex((sb) => sb.id === box.id);
    if (index > -1) {
      this.selectedBox.splice(index, 1); // remove only one occurrence
    }
  }

  getSelectBoxQuantity(box: ShipmentBoxModel): number {
    return this.selectedBox.filter((sb) => sb.id === box.id).length;
  }

  onConfirm() {
    this.confirmBoxes.emit(this.selectedBox); // send to parent
  }

  cancelBoxSelection() {
    this.selectedBox = [];
  }

  getUniqueBoxes(boxes: ShipmentBoxModel[]) {
    const boxCountMap = new Map<number, { box: ShipmentBoxModel; count: number }>();
    boxes.forEach((box) => {
      if (boxCountMap.has(box.id)) {
        boxCountMap.get(box.id)!.count++;
      } 
      else {
        boxCountMap.set(box.id, { box, count: 1 });
      }
    });

    return Array.from(boxCountMap.values());
  }
}
